import React, {useEffect} from 'react';
import {Col, Divider, Row, Space} from 'antd';

// Components and Subcomponents
import ButtonComponent from '../subComponents/ButtonComponent';
import TitleComponent from '../subComponents/TitleComponent';

// Store
import {useAppDispatch} from "../../store/store";
import {decryptTempToken} from "../../store/redux/actions/authActions";

// Constants and Functions
import {routes} from '../../utils/routes';
import {getWindowInformation, redirectWindow} from '../../utils/functions';

// Assets
import logo from '../../assets/DKT_Lockup_Primary_Blue_RGB.png';


const Login = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const { pathname, search } = getWindowInformation();

    if(pathname === routes.authentication){
        const urlParams = new URLSearchParams(search);
        const code = urlParams.get('c') ?? '';

        dispatch(decryptTempToken(code));
      }
  }, []);

  const handleLogin = () => {
    redirectWindow(routes.oauth);
  };

  return (
    <Row className={'session-container flex min-h-screen bg-grey-dkt-100 bg-no-repeat bg-cover'}
         style={{ backgroundImage: 'url(\'https://idpdecathlon.oxylane.com/assets/images/3.jpg\')' }}>
      <Col className={'sm:mx-auto sm:w-full sm:max-w-md m-auto bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'}>
        <Col md={24} >
          <img src={logo} />
        </Col>
        <Col md={24}>
          <TitleComponent level={2} text={'Inicia Sesión'}
                          className={'my-8 text-center text-grey-dkt-400'} />
        </Col>
        <Col md={24}>
          <ButtonComponent text={'Ingresa con cuenta de Decathlon'}
                           className={'w-full p-2 text-white bg-orange-dkt-400 hover:bg-orange-dkt-500 focus:outline-none ' +
                             'focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-300 '
                           }
                           onClick={handleLogin}
          />
        </Col>

        <Divider />

        <Col className={'text-center mt-2'}>
          <Space direction={'horizontal'} split={<Divider type={'vertical'} className={'bg-blue-dkt-200'} />}>
            <a href={routes.carrierAccount.login}
               className={'text-blue-dkt-500 hover:underline font-semibold'}>Soy transportista</a>
            <a href={routes.supplierAccount.login}
               className={'text-blue-dkt-500 hover:underline font-semibold'}>Soy proveedor</a>
          </Space>
        </Col>
      </Col>
    </Row>
  );
}

export default Login;